import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementPostMetricsForInsightCheck.graphql';
import { Query, QueryengagementPostMetricsForInsightCheckArgs } from '../../__generated__/globalTypes';

export const useEngagementPostMetricsForInsightCheckQuery = (
  options?: QueryHookOptions<Query, QueryengagementPostMetricsForInsightCheckArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementPostMetricsForInsightCheckArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementPostMetricsForInsightCheckLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementPostMetricsForInsightCheckArgs>
): QueryResult<Query, QueryengagementPostMetricsForInsightCheckArgs> & {
  getEngagementPostMetricsForInsightCheck: LazyQueryExecFunction<Query, QueryengagementPostMetricsForInsightCheckArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementPostMetricsForInsightCheck, result] = useLazyQuery<
    Query,
    QueryengagementPostMetricsForInsightCheckArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getEngagementPostMetricsForInsightCheck, ...result };
};

export const useEngagementPostMetricsForInsightCheckPromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementPostMetricsForInsightCheck = useCallback(
    (options?: Omit<QueryOptions<QueryengagementPostMetricsForInsightCheckArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementPostMetricsForInsightCheckArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementPostMetricsForInsightCheck };
};
// Suspense Query Hooks
export const useEngagementPostMetricsForInsightCheckSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementPostMetricsForInsightCheckArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementPostMetricsForInsightCheckArgs>(QUERY, {
    ...options
  });

  return result;
};
